<template lang="pug">
.section-container.section-home
	section-code-enel(:num="1")

	section-intro
	section-video(:num="2")
	section-features(:num="3")
	section-luciano(:num="4")
	section-partners(:num="5")

	section.section.border-bottom-section
		.section-content
			.columns.is-centered.is-vcentered
				.column.is-narrow.has-text-centered
					img(src="/icon.png" style="width: 100px;display:inline-block;")
				.column.has-text-centered-md
					.title.is-spaced(style="margin-bottom: .5rem;")
						| {{ $t('about.title_start_workout') }}
					p.subtitle(style="margin-bottom: .5rem;")
						| {{ $t('about.solutions_from') }}
				.column.is-narrow
					p.subtitle.has-text-centered(style="margin-bottom: .5rem;")
						| {{ $t('about.download_app') }}
					.app-container.justify-center-md(style="justify-content:flex-end;")
						a(href='https://play.google.com/store/apps/details?id=com.fitnessdadivano.app' target='_blank' style="max-width:140px")
							img(src="/img/google_play_badge.svg", alt="Android", title="Android")
						a(href='https://itunes.apple.com/it/app/id1531130588?mt=8' target='_blank' style="max-width:140px")
							img(src="/img/app_store_badge.svg", alt="iOS", title="iOS")

	section-form(ref="sectionform")

	modal-comp.modal-video(ref="modalvideo" :title="$t('menu.video')" @close="videoPopupClosed")
		.columns.is-centered.is-vcentered(v-if="videoPopup")
			video(width="854" height="480" controls ref="playervideo")
				source(src="/videos/workout-ita.mp4" type="video/mp4")
				| {{ $t('home.no_video_support') }}
</template>

<script>
import ModalComponent from '../components/ModalComponent.vue'
import SectionIntro from '../components/sections/SectionIntro.vue'
import SectionLuciano from '../components/sections/SectionLuciano.vue'
import SectionFeatures from '../components/sections/SectionFeatures.vue'
import SectionVideo from '../components/sections/SectionVideo.vue'
import SectionPartners from '../components/sections/SectionPartners.vue'

import SectionForm from '../components/sections/SectionForm.vue'
import SectionCodeEnel from '../components/sections/SectionCodeEnel.vue'

export default {
	components: {
		ModalComp: ModalComponent,
		SectionIntro,
		SectionLuciano,
		SectionFeatures,
		SectionVideo,
		SectionPartners,
		SectionForm,
		SectionCodeEnel
	},
	data() {
		return {
			videoPopup: false,
		}
	},
	computed: {
		language() {
			return this.$t('locale.lang')
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.home") })
		document.getElementsByTagName("BODY")[0].classList.add('page-header')
	},
	methods: {
		openVideoPopup() {
			this.$refs.modalvideo.open()
			this.videoPopup = true
		},
		videoPopupClosed() {
			this.$refs.playervideo.pause()
		}
	},
	watch: {
		language() {
			if (this.videoPopup) {
				this.$refs.modalvideo.close()
				this.videoPopup = false
			}
		}
	}
}
</script>
